import * as React from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

const ITEM_HEIGHT = 48

export default function LongMenu({
  open,
  anchorEl,
  options,
  handleClose = () => {},
  handleClick = () => {},
}) {
  return (
    <div>
      <Menu
        id='long-menu'
        anchorEl={anchorEl}
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: 'auto',
          },
        }}
      >
        {options?.map((option) => (
          <MenuItem key={option?.type} onClick={() => handleClick(option)}>
            {option?.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}
